"use client";

import { useEffect, useState } from "react";
import { PrismicNextImage } from "@prismicio/next";
import LazyLoadBackground from "@/components/LazyLoadBackground";
import Link from "next/link";
import { Icon } from "@iconify/react";
import { Bounded } from "@/components/Bounded";
import { Button } from "@/components/Button";
import { Container } from "@/components/Container";
import vectorDots from "@/images/Vector-Dots.svg";
import vectorHalfCircleGreen from "@/images/Vector-half-circle3.svg";
import Image from "next/image";

export default function HeroOpener({ slice }) {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newScale = 1 + scrollY * 0.0005; // Adjust the zoom factor as needed
      setScale(newScale);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/* <section id={slice.primary.anchor || undefined} className="mx-auto"> */}
      <div className="relative bg-gray-100 w-screen h-[calc(100vh-87px)] overflow-hidden">
        {" "}
        <Image
          src={slice.primary.image.url}
          alt="Hero background"
          fill
          style={{
            objectFit: "cover",
            transform: `scale(${scale})`,
          }}
          priority
        />
        <PrismicNextImage
          field={slice.primary.logo}
          alt={slice.primary.logo.alt}
          className="absolute top-[57%] left-0 right-0 mx-auto z-10 w-72"
        />
        <Link
          href="#about"
          className="scroll-down-arrow w-inline-block"
          aria-label="Scroll down"
        >
          <Icon
            icon="pepicons-pencil:arrow-down"
            className="absolute bottom-[5%] left-[48%] text-white w-10 h-10 animate-bounce"
          />
        </Link>
      </div>
      {/* </section> */}
    </>
  );
}
